 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT1COVER from '@/components/Text/1-cover'
 import TEXTBIRDSFRONT from '@/components/Text/birdsfront'
 import ADVERTFRONTADD from '@/components/Advert/Front-add'
 import TEXTLOVE_1 from '@/components/Text/love_1'
 import TEXT2TITLE_PAGE from '@/components/Text/2-title_page'
 import TEXT3TOC from '@/components/Text/3-TOC'
 import TEXT4START from '@/components/Text/4-start'
 import TEXT6CHAP2 from '@/components/Text/6-chap2'
 import TEXT7CHAP5 from '@/components/Text/7-chap5'
 import TEXT8CHAP8 from '@/components/Text/8-chap8'
 import TEXT9CHAP12 from '@/components/Text/9-chap12'
 import TEXT10CHAP16 from '@/components/Text/10-chap16'
 import TEXT11CHAP22 from '@/components/Text/11-chap22'
 import TEXT12CHAP28 from '@/components/Text/12-chap28'
 import TEXT13PART2 from '@/components/Text/13-part2'
 import TEXT14CHAP34 from '@/components/Text/14-chap34'
 import TEXT15CHAP38 from '@/components/Text/15-chap38'
 import TEXT16CHAP43 from '@/components/Text/16-chap43'
 import TEXT17CHAP46 from '@/components/Text/17-chap46'
 import TEXT18CHAP49 from '@/components/Text/18-chap49'
 import TEXT19CHAP54 from '@/components/Text/19-chap54'
 import TEXT20CHAP58 from '@/components/Text/20-chap58'
 import TEXT21PART3 from '@/components/Text/21-part3'
 import TEXT22CHAP62 from '@/components/Text/22-chap62'
 import TEXT23CHAP70 from '@/components/Text/23-chap70'
 import TEXT24CHAP73 from '@/components/Text/24-chap73'
 import TEXT25CHAP77 from '@/components/Text/25-chap77'
 import TEXT26CHAP83 from '@/components/Text/26-chap83'
 import TEXT27CHAP87 from '@/components/Text/27-chap87'
 import TEXT28PART4 from '@/components/Text/28-part4'
 import TEXT29CHAP92 from '@/components/Text/29-chap92'
 import TEXT30CHAP97 from '@/components/Text/30-chap97'
 import TEXT31CHAP104 from '@/components/Text/31-chap104'
 import TEXT32CHAP114 from '@/components/Text/32-chap114'
 import TEXT33CHAP122 from '@/components/Text/33-chap122'
 import TEXT34CHAP126 from '@/components/Text/34-chap126'
 import TEXT35CHAP129 from '@/components/Text/35-chap129'
 import TEXT36CHAP132 from '@/components/Text/36-chap132'
 import TEXT37PART5 from '@/components/Text/37-part5'
 import TEXT38CHAP137 from '@/components/Text/38-chap137'
 import TEXT39CHAP144 from '@/components/Text/39-chap144'
 import TEXT40CHAP152 from '@/components/Text/40-chap152'
 import TEXT41CHAP156 from '@/components/Text/41-chap156'
 import TEXT42CHAP161 from '@/components/Text/42-chap161'
 import TEXT43CHAP165 from '@/components/Text/43-chap165'
 import TEXT44CHAP168 from '@/components/Text/44-chap168'
 import TEXT45CHAP173 from '@/components/Text/45-chap173'
 import TEXT46PART6 from '@/components/Text/46-part6'
 import TEXT47CHAP176 from '@/components/Text/47-chap176'
 import TEXT48CHAP182 from '@/components/Text/48-chap182'
 import TEXT49CHAP187 from '@/components/Text/49-chap187'
 import TEXT50CHAP191 from '@/components/Text/50-chap191'
 import TEXT51CHAP194 from '@/components/Text/51-chap194'
 import TEXT52CHAP198 from '@/components/Text/52-chap198'
 import TEXT53CHAP202 from '@/components/Text/53-chap202'
 import TEXTLOVE_2 from '@/components/Text/love_2'
 import TEXT54BIO from '@/components/Text/54-bio'
 import TEXT55COPYRIGHT from '@/components/Text/55-copyright'
 import TEXT56AD1 from '@/components/Text/56-ad1'
 import TEXTORIMAD from '@/components/Text/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/3-TOC",
 			"name" : "Text/3-TOC",
 			"component" : TEXT3TOC
 		},
 		{
 			"path" : "/Text/4-start",
 			"name" : "Text/4-start",
 			"component" : TEXT4START
 		},
 		{
 			"path" : "/Text/6-chap2",
 			"name" : "Text/6-chap2",
 			"component" : TEXT6CHAP2
 		},
 		{
 			"path" : "/Text/7-chap5",
 			"name" : "Text/7-chap5",
 			"component" : TEXT7CHAP5
 		},
 		{
 			"path" : "/Text/8-chap8",
 			"name" : "Text/8-chap8",
 			"component" : TEXT8CHAP8
 		},
 		{
 			"path" : "/Text/9-chap12",
 			"name" : "Text/9-chap12",
 			"component" : TEXT9CHAP12
 		},
 		{
 			"path" : "/Text/10-chap16",
 			"name" : "Text/10-chap16",
 			"component" : TEXT10CHAP16
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js